import { FEEDING_STATUS } from '../../../config/constants';

const STATUS_CONFIG = {
  [FEEDING_STATUS.GREEN]: {
    label: 'Al día',
    bgClass: 'bg-status-green',
    ringClass: 'ring-status-green/30',
    pulseClass: '',
  },
  [FEEDING_STATUS.YELLOW]: {
    label: 'Pronto',
    bgClass: 'bg-status-yellow',
    ringClass: 'ring-status-yellow/30',
    pulseClass: '',
  },
  [FEEDING_STATUS.RED]: {
    label: 'Urgente',
    bgClass: 'bg-status-red',
    ringClass: 'ring-status-red/30',
    pulseClass: 'animate-pulse',
  },
  [FEEDING_STATUS.UNKNOWN]: {
    label: 'Sin datos',
    bgClass: 'bg-slate-300',
    ringClass: 'ring-slate-300/30',
    pulseClass: '',
  },
};

/**
 * Semáforo visual de estado de alimentación / hidratación.
 *
 * El componente es agnóstico al dominio — solo refleja un status genérico
 * (verde/amarillo/rojo/desconocido). Para distinguir dos semáforos del mismo
 * card (comida + agua), el caller puede pasar `icon` (componente lucide) y
 * el variant `badge` lo renderiza entre el dot y el label.
 *
 * Variantes:
 *  - dot: solo el círculo (para listas compactas). `icon` se ignora.
 *  - badge: círculo + (icon opcional) + label (para PetCard).
 *  - large: círculo grande con label debajo (para PetDetailPage). `icon` se ignora.
 */
const StatusTrafficLight = ({ status, variant = 'badge', icon: Icon = null, className = '' }) => {
  const cfg = STATUS_CONFIG[status] ?? STATUS_CONFIG[FEEDING_STATUS.UNKNOWN];

  if (variant === 'dot') {
    return (
      <span
        role="status"
        aria-label={`Estado: ${cfg.label}`}
        className={[
          'inline-block h-3 w-3 rounded-full ring-4',
          cfg.bgClass,
          cfg.ringClass,
          cfg.pulseClass,
          className,
        ].join(' ')}
      />
    );
  }

  if (variant === 'large') {
    return (
      <div className={['flex flex-col items-center gap-2', className].join(' ')}>
        <span
          role="status"
          aria-label={`Estado: ${cfg.label}`}
          className={[
            'h-6 w-6 rounded-full ring-8',
            cfg.bgClass,
            cfg.ringClass,
            cfg.pulseClass,
          ].join(' ')}
        />
        <span className="text-sm font-medium text-slate-700">{cfg.label}</span>
      </div>
    );
  }

  // badge (default)
  return (
    <span
      role="status"
      className={[
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1',
        'text-xs font-medium text-slate-700',
        'bg-white ring-1 ring-slate-200',
        className,
      ].join(' ')}
    >
      <span
        aria-hidden="true"
        className={[
          'h-2 w-2 rounded-full',
          cfg.bgClass,
          cfg.pulseClass,
        ].join(' ')}
      />
      {Icon && <Icon className="h-3 w-3 text-slate-500" aria-hidden="true" />}
      {cfg.label}
    </span>
  );
};

export default StatusTrafficLight;